import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { createCoupon, CreateCouponPayload } from '@/api/coupons';

export function useCreateCoupon() {
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError<{ message?: string }>, CreateCouponPayload>({
    mutationFn: createCoupon,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['merchant', variables.merchantId] });
    },
  });
}
